var map = {
	"./Climate-change-vs-environmental-protection.jpg": 8035,
	"./ESG-Investing.jpg": 9250,
	"./Financed-emissions.jpg": 2899,
	"./Towards-environmental-sustainability-How-SAB-is-taking-action.jpg": 4679,
	"./Understanding-the-evolution-of-ESG-from-niche-to-mainstream-practice.jpg": 9852,
	"./emissions-ar.svg": 4879,
	"./emissions.svg": 8572,
	"./image-2.jpg": 2016,
	"./image-3.jpg": 4043,
	"./image-4.jpg": 4207,
	"./image-5.jpg": 4205,
	"./plan-1-ar.jpg": 3221,
	"./plan-1.png": 4606,
	"./why-is-sustainbaility-important.jpg": 6017
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4325;